import { LayoutProps } from 'components/atoms/Layout/interfaces'
import { InputBuildProps } from 'components/molecules/InputBuild/interfaces'

export const InputFormRegistration: {
    input: InputBuildProps
    layout: LayoutProps
}[] = [
    {
        input: {
            id: 'nome',
            label: 'Nome completo',
            required: true,
            disabled: true,
            maxLength: 128
        },
        layout: {
            type: 'col',
            layout: { base: 12 }
        }
    },
    {
        input: {
            id: 'nomeUsuario',
            label: 'Usuário ou e-mail',
            maxLength: 128,
            required: true
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    },
    {
        input: {
            id: 'cpf',
            label: 'CPF',
            required: true,
            maskReplace: 'cpf',
            disabled: true
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    },
    {
        input: {
            id: 'senha',
            label: 'Senha',
            type: 'password',
            required: true,
            maxLength: 30
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    },
    {
        input: {
            id: 'senhaConfirmacao',
            label: 'Confirmação de senha',
            type: 'password',
            required: true,
            maxLength: 30
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    }
]
